

































































































































































import { namespace } from "vuex-class";
import { Component, Ref, Vue } from "vue-property-decorator";
import PassportSvg from "@/modules/passport/components/PassportSvg.vue";
import PassportDesktopSvg from "@/modules/passport/components/PassportDesktopSvg.vue";
import PreviousPageArrow from "@/components/PreviousPageArrow.vue";
import { base64toBlob } from "@/utils/index";
import {
  DocumentType,
  UploadPayload,
  DocumentSide,
} from "@/modules/document/types";

import heic2any from "heic2any";
import Loader from "@/components/svg/Loader.vue";
import axios from "axios";

const Document = namespace("document");
const Trn = namespace("trn");

@Component({
  metaInfo() {
    return {
      title: "Orba One | Take Your Passport",
    };
  },
  components: {
    "passport-svg": PassportSvg,
    "passport-svg-desktop": PassportDesktopSvg,
    "previous-page-arrow": PreviousPageArrow,
    loader: Loader,
  },
})
export default class CapturePassport extends Vue {
  @Document.Action("upload") upload!: (payload: UploadPayload) => Promise<{}>;
  @Trn.Getter("getTrn") trn!: string;
  @Document.Getter("getCountryCode") countryCode!: string;
  @Ref() previewDocument!: HTMLImageElement;
  base64Image = "";
  isImageLoaded = false;
  isUploading = false;
  isUploadingError = false;
  isValidationError = false;
  imageBlob?: Blob;
  errorMessage = "";

  async mounted() {
    try {
      if (Vue.prototype.$useAudioInstructions) {
        Vue.prototype.$audioConfigs.stopEnterTrn?.();
        await Vue.prototype.$audioConfigs.playUploadPassport?.();
      }
    } catch (err) {
      console.warn("Audio playback failed:", err);
    }
  }

  previewImage(files: FileList | File[]) {
    const file: File = files[0];
    if (!file) return;

    const fileName = file.name.toLowerCase();
    this.isValidationError = false;

    // Block PDF uploads
    if (file.type === "application/pdf" || fileName.endsWith(".pdf")) {
      this.showErrorToast(
        "PDF files are not supported. Please upload an image instead."
      );
      return;
    }

    const processFile = (blob: Blob) => {
      const reader = new FileReader();
      reader.onload = async (event) => {
        if (event && event.target) {
          this.base64Image = event.target.result as string;
          this.imageBlob = await base64toBlob(this.base64Image);
          this.isImageLoaded = true;

          if (Vue.prototype.$useAudioInstructions) {
            Vue.prototype.$audioConfigs.stopUploadPassport();
            await Vue.prototype.$audioConfigs.playPassportReadability();
          }
        }
      };
      reader.readAsDataURL(blob);
    };

    // HEIC / HEIF support
    if (
      file.type === "image/heic" ||
      file.type === "image/heif" ||
      fileName.endsWith(".heic") ||
      fileName.endsWith(".heif")
    ) {
      heic2any({ blob: file, toType: "image/jpeg", quality: 0.9 })
        .then((result: Blob | Blob[]) => {
          const convertedBlob = Array.isArray(result) ? result[0] : result;
          processFile(convertedBlob);
        })
        .catch((err: any) => {
          console.error("HEIC conversion failed:", err);
          this.showErrorToast(
            "Failed to convert HEIC image. Please try again or use a JPEG/PNG."
          );
        });
    } else {
      processFile(file);
    }
  }

  showErrorToast(message: string) {
    this.isValidationError = true;
    this.errorMessage = message;

    // Auto-hide after 5 seconds
    setTimeout(() => {
      this.isValidationError = false;
    }, 5000);
  }

  retryImage() {
    this.isImageLoaded = false;
    this.isValidationError = false;
    this.base64Image = "";
    this.imageBlob = undefined;
  }

  confirmImage() {
    this.uploadNationalFront();
  }

  uploadNationalFront(): void {
    const params = new URLSearchParams(window.location.search);
    const publicKey = params.get("publicKey");
    const applicantId = params.get("applicantId");

    const formData = new FormData();

    if (publicKey && applicantId) {
      formData.append("applicantId", applicantId);
      formData.append("publicKey", publicKey);
      formData.append("type", DocumentType.PASSPORT);
      formData.append("side", DocumentSide.FRONT);
      formData.append("TaxId", this.trn);
      formData.append("countryCode", this.countryCode);

      if (this.imageBlob) {
        formData.append(
          `file`,
          this.imageBlob,
          `passport_${applicantId}_${publicKey}.png`
        );
      }

      this.isUploading = true;
      this.isUploadingError = false;
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      this.upload(formData)
        .then(() => {
          self.passportUploaded();
          this.isUploading = false;
          this.$router.push({ name: "finish", query: this.$route.query });

          if (Vue.prototype.$useAudioInstructions) {
            Vue.prototype.$audioConfigs.stopPassportReadability();
          }
          if (Vue.prototype.$useAudioInstructions) {
            Vue.prototype.$audioConfigs.playUploadIsCompleted();
          }
        })
        .catch(() => {
          if (Vue.prototype.$useAudioInstructions) {
            Vue.prototype.$audioConfigs.stopPassportReadability();
          }
          if (Vue.prototype.$useAudioInstructions) {
            Vue.prototype.$audioConfigs.playPassportFailed();
          }

          this.isValidationError = true;
          this.isUploading = false;
          this.isUploadingError = true;
        });
    }
  }

  isMobile(): boolean {
    if (screen.width <= 760) {
      return true;
    } else {
      return false;
    }
  }

  passportUploaded() {
    const params = new URLSearchParams(window.location.search);
    const publicKey = params.get("publicKey");
    const applicantId = params.get("applicantId");
    const magicLink = params.get("magic");
    const progressionStep = 10;

    if ((publicKey && applicantId) || magicLink) {
      axios.put(
        `${process.env.VUE_APP_API_URL}/applicants/${applicantId}/verification-progress-step`,
        {
          publicKey,
          progressionStep,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    }
  }
}
